import {
  faVenus,
  faMars,
  faCircleNotch,
} from "@fortawesome/free-solid-svg-icons";
import OptionsCheckboxFilter, {
  OptionItem,
} from "../options-checkbox-filter/OptionsCheckboxFilter";
import { BaseFilterProps } from "interfaces/filter-component-base";
import "./GenderFilter.scss";

const genderOptions: OptionItem[] = [
  {
    label: "Female",
    value: "female",
    description: "Female creators",
    icon: faVenus,
    iconClassName: "female",
  },
  {
    label: "Male",
    value: "male",
    description: "Male creators",
    icon: faMars,
    iconClassName: "male",
  },
  {
    label: "Other",
    value: "nonBinary",
    description: "Non-binary & other",
    icon: faCircleNotch,
    iconClassName: "other",
  },
];

const GenderFilter = (props: BaseFilterProps) => {
  return <OptionsCheckboxFilter {...props} options={genderOptions} />;
};

export default GenderFilter;
